import { createFileRoute } from '@tanstack/react-router'
import { ChartPieIcon } from 'lucide-react'

export const Route = createFileRoute('/_auth/_modules/_app/reports')({
  staticData: {
    title: 'route.reports',
    crumb: 'route.reports',
    icon: ChartPieIcon,
    permissions: ['reports_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
